import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8,25H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7H16.586L14.293,9.293a1,1,0,1,0,1.414,1.414l4-4h0a1,1,0,0,0,0-1.414h0l-4-4a1,1,0,0,0-1.414,1.414L16.586,5H5A3,3,0,0,0,2,8V24a3,3,0,0,0,3,3H8a1,1,0,0,0,0-2Z"/><path d="M27,5H24a1,1,0,0,0,0,2h3a1,1,0,0,1,1,1V24a1,1,0,0,1-1,1H15.414l2.293-2.293a1,1,0,1,0-1.414-1.414l-4,4h0a1,1,0,0,0,0,1.414h0l4,4a1,1,0,0,0,1.414-1.414L15.414,27H27a3,3,0,0,0,3-3V8A3,3,0,0,0,27,5Z"/>';
export var SyncSVG = function SyncSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SyncSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SyncSVG);